import { render, staticRenderFns } from "./TbChat.vue?vue&type=template&id=708f1281&scoped=true"
import script from "./TbChat.vue?vue&type=script&lang=js"
export * from "./TbChat.vue?vue&type=script&lang=js"
import style0 from "./TbChat.vue?vue&type=style&index=0&id=708f1281&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f1281",
  null
  
)

export default component.exports